import React from "react";

import Message from "controls/Message";
import filterBlobUrl from "helpers/filterBlobUrl";

// Shown when a preview cannot be rendered in this browser (or the preview
// itself is broken); the original file can still be opened natively.
export default function PreviewUnavailable({ previewable, children }) {
  return (
    <Message
      type="error"
      actions={[
        {
          title: "打开文件",
          href: filterBlobUrl(previewable.blobUrl),
          target: "_blank",
        },
        {
          title: "下载文件",
          href: filterBlobUrl(previewable.blobDownloadUrl),
        },
      ]}
    >
      {children || <>无法预览该文件，您可以直接打开该文件进行查看</>}
    </Message>
  );
}
